import { gql } from '@apollo/client';

import { CreateMultipleChoiceExerciseInput, MultipleChoiceExercise } from '../../types';
import { multipleChoiceExerciseFragment } from '../fragments';

export interface UpdateMultipleChoiceExerciseMutationVariables {
  courseId: string;
  subjectId: string;
  exerciseId: string;
  input: CreateMultipleChoiceExerciseInput;
}

export interface UpdateMultipleChoiceExerciseMutationResult {
  multipleChoiceExercise: MultipleChoiceExercise;
}

export const updateMultipleChoiceExerciseMutation = gql`
  mutation UpdateMultipleChoiceExerciseMutation(
    $courseId: String!
    $subjectId: String!
    $exerciseId: String!
    $input: UpdateMultipleChoiceExerciseMutationInput!
  ) {
    multipleChoiceExercise(courseId: $courseId, subjectId: $subjectId, exerciseId: $exerciseId, input: $input)
      @rest(type: "Exercise", path: "courses/{args.courseId}/subjects/{args.subjectId}/exercises/{args.exerciseId}", method: "PUT") {
      ...MultipleChoiceExercise
    }
  }
  ${multipleChoiceExerciseFragment}
`;
